import { usePaymentMethod } from 'src/contexto/hooks/usePaymentMethod'
import { PaymentMethodsEnum } from '../enums/payment-methods'
import { paymentMethodsIconsMap } from '../payment-methods-icons'

export const usePaymentMethodsIcons = () => {
  const { paymentMethodStore } = usePaymentMethod()

  const activeStatus = 1

  const activePaymentMethodsStore = paymentMethodStore.filter(
    ({ status }) => status === activeStatus
  )

  const orderIcons = [
    PaymentMethodsEnum.Credit_card,
    PaymentMethodsEnum.Billet,
    PaymentMethodsEnum.Pix,
  ]

  const sortedPaymentMethods = activePaymentMethodsStore
    .filter(({ slug }) => orderIcons.includes(slug as PaymentMethodsEnum))
    .sort(
      (a, b) =>
        orderIcons.indexOf(a.slug as PaymentMethodsEnum) -
        orderIcons.indexOf(b.slug as PaymentMethodsEnum)
    )

  return sortedPaymentMethods?.map(({ slug }) => paymentMethodsIconsMap[slug])
}
